import React, { forwardRef } from "react";

const IconButton = React.forwardRef((props, ref) => {
  return (
    <button {...props} ref={ref} className={`btn IconButton ${props.className ?? ""}`}>
      {props.children ? props.children : null}
      {props?.icon ? <span className="d-inline-block ml-2">{props.icon}</span> : null}
    </button>
  );
});

IconButton.displayName = "IconButton";

IconButton.NoButton = React.forwardRef((props, ref) => {
  return (
    <div {...props} ref={ref} className={`btn IconButton ${props.className ?? ""}`}>
      {props.children ? props.children : null}
      {props?.icon ? <span className="d-inline-block ml-2">{props.icon}</span> : null}
    </div>
  );
});

IconButton.NoButton.displayName = "IconButton.NoButton";

export default IconButton;
